// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yxSmB-X1Xt0TglRF4i206{padding-top:2.4rem;padding-bottom:2.4rem;background:#fff;text-align:center}._1-L5IsILQVq5usPetxgLUb,._1k19B_HhihEyld07ibMzoD{margin-top:3.6rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "yxSmB-X1Xt0TglRF4i206",
	"button": "_1-L5IsILQVq5usPetxgLUb",
	"details": "_1k19B_HhihEyld07ibMzoD"
};
module.exports = ___CSS_LOADER_EXPORT___;
